import { Tag as TagAD } from 'antd';
import cs from 'classnames';
import type { ComponentProps } from 'react';
import { useTranslation } from 'react-i18next';

// TODO: unify this component with Tag in @pba/react-components
export type TagProperties = {
  bordered?: boolean;
  color?: TagSupportedColors;
  format?: { upperCase?: boolean };
  iconNoneMargin?: boolean;
  padding?: boolean;
  rounded?: boolean;
  size?: 'extra-small' | 'large' | 'medium' | 'small';
} & Omit<ComponentProps<typeof TagAD>, 'color'>;

type TagSupportedColors =
  | 'bg-none'
  | 'blue'
  | 'cyan'
  | 'error'
  | 'green'
  | 'live'
  | 'orange'
  | 'pink'
  | 'purple'
  | 'success'
  | 'warning';

const Tag = ({
  bordered,
  children,
  className,
  color,
  format,
  iconNoneMargin,
  padding,
  rounded,
  size,
  ...rest
}: TagProperties) => {
  const { t } = useTranslation();
  return (
    <TagAD
      className={cs(
        'ui-tag',
        {
          'ui-tag--bg-none': color === 'bg-none',
          'ui-tag--blue': color === 'blue',
          'ui-tag--cyan': color === 'cyan',
          'ui-tag--error': color === 'error',
          'ui-tag--extra-small': size === 'extra-small',
          'ui-tag--framed': bordered,
          'ui-tag--green': color === 'green',
          'ui-tag--icon-none-margin': iconNoneMargin,
          'ui-tag--large': size === 'large',
          'ui-tag--live': color === 'live',
          'ui-tag--medium': size === 'medium',
          'ui-tag--orange': color === 'orange',
          'ui-tag--padding-none': padding === false,
          'ui-tag--pink': color === 'pink',
          'ui-tag--purple': color === 'purple',
          'ui-tag--rounded': rounded,
          'ui-tag--small': size === 'small',
          'ui-tag--success': color === 'success',
          'ui-tag--uppercase': format?.upperCase,
          'ui-tag--warning': color === 'warning',
        },
        className,
      )}
      {...rest}
    >
      {typeof children === 'string' ? t(children) : children}
    </TagAD>
  );
};

export default Tag;
